import {  createSlice } from '@reduxjs/toolkit';


const initialState = {
   form:{}
  }

const listDetailFormSlice = createSlice({
    name:'listDetailFormSlice',
    initialState,
    reducers:{
        setFormInfo(state,action){
            state.form= action.payload
        },
    }
});

export const {
    setFormInfo
} = listDetailFormSlice.actions;

export default listDetailFormSlice.reducer;




